export default __webpack_public_path__ + "static/media/TaxPayerLogoEnglish.d739977f.svg";